export default __webpack_public_path__ + "static/media/traceai_logo.0499fc30.png";